module.exports = __webpack_public_path__ + "img/notification.34aa554c.svg";